import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptCarouselBanners } from "../../adapters/adaptCarouselBanners";

const fetchBannerLibrary = async () => {
	const response = await cmsClient.get<IBanner[]>(
		"/homepage/admin/carouselbanner/",
		{
			params: {
				published: false
			}
		}
	);

	return response.data;
};

interface Options {
	onSuccess?: (banners: Banner[]) => void;
}

const useBannerLibrary = (options: Options = {}) => {
	const query = useQuery(["banner-library"], fetchBannerLibrary, {
		select: adaptCarouselBanners,
		...options
	});

	return query;
};

export default useBannerLibrary;
